import React from 'react';
import { Link, NavLink } from 'react-router-dom'; // <-- IMPORT THIS
import logoIcon from '../images/logo_Icon.png';
import { 
  FaSun,
  FaMoon 
} from 'react-icons/fa';

// Your existing Header component, with <NavLink> and <Link>
export default function Header({ toggleTheme, currentTheme }) {
  return (
    <header className="header">
      <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img src={logoIcon} alt="CeyloNext Logo" className="logo-image" style={{ width: '45px', height: '45px' }} />
        <strong>CeyloNext</strong>
      </div>
      <nav className="navigation">
        {/* Use NavLink for navigation links. 
            It automatically adds an 'active' class, which matches your CSS! 
            The 'end' prop on Home ensures it's only active for the home page. */}
        <NavLink to="/" className="nav-item" end>Home</NavLink>
        <NavLink to="/services" className="nav-item">Services</NavLink>
        {/* <NavLink to="/projects" className="nav-item">Projects</NavLink> */}
        <NavLink to="/about" className="nav-item">About Us</NavLink>
      </nav>
      
      <div className="header-right">
        {/* Use Link for the button */}
        <Link to="/contact" className="contact-button">Contact Us</Link>
        <button className="theme-toggle" onClick={toggleTheme}>
          {currentTheme === 'dark' ? <FaSun /> : <FaMoon />}
        </button>
      </div>
    </header>
  );
}